<template>
    <div>
        <div class="image is-background-image is-3by2"
             :style="{backgroundImage: `url('${contentUrlPrefix + photo.url}')`}"
             :title="decodeURIComponent(photo.url.substring(photo.url.indexOf('-') + 1, photo.url.indexOf('?')))">
            <div class="select-container has-centered-content"
                 :class="{selected}"
                 @click="$emit('input', photo.url)">
                <font-awesome-icon icon="check"/>
            </div>
            <div class="more-button" @click.prevent="$emit('more', photo)">
                <font-awesome-icon icon="chevron-circle-down" fixed-width></font-awesome-icon>
            </div>
        </div>
    </div>
</template>

<script>
    import {contentUrlPrefix} from "../firebase";

    export default {
        props: {
            photo: {
                type: Object,
                required: true
            },
            selected: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                contentUrlPrefix
            }
        }
    }
</script>

<style lang="scss">
    .image.is-background-image {
        background-size: cover;
        background-position: center;
        border-radius: 6px;
        box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);

        .more-button {
            position: absolute;
            top: 5px;
            right: 5px;
            color: rgba(255, 255, 255, 0.5);
            transition: color 0.5s ease-in-out;
            cursor: pointer;

            &:hover {
                color: white;
            }
        }
    }

    .select-container {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;

        background-color: rgba(0, 0, 0, 0.25);

        opacity: 0;
        transition: opacity 0.3s ease-in-out;

        cursor: pointer;

        svg {
            color: white;
            opacity: 0;
            transition: opacity 0.3s ease-in-out;
        }

        &:hover {
            opacity: 0.5;
        }

        &.selected {
            opacity: 1;

            svg {
                opacity: 1;
            }
        }
    }
</style>